import React, { useState, useEffect } from 'react';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { FaCamera, FaTimes } from 'react-icons/fa';
import UploadFilesContainer from '../../../../../models/upload-url-file';

export default function TemplateInfoComponent({
  isAttachment,
  handleInnerFormChange,
  selectedTemplate,
}: any) {
  const [isModalMediaOpen, setModalOpen] = useState(false);
  const [imageUrls, setImageUrls] = useState<string[]>([]);

  // Populate imageUrls with the existing Attachmenturls from selectedTemplate
  useEffect(() => {
    if (selectedTemplate?.Attachmenturls?.length > 0) {
      setImageUrls(selectedTemplate.Attachmenturls);
    }
  }, [selectedTemplate]);

  const openModal = (e: any) => {
    e.stopPropagation();
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleSaveUrls = (urls: string[]) => {
    setImageUrls(urls);
    selectedTemplate.Attachmenturls = urls; // Update selectedTemplate with new URLs
    closeModal();
  };

  return (
    <>
      <AccordionContainer
        child={
          <div className="flex items-center space-x-4">
            {/* Display the existing or newly uploaded image URLs */}
            {imageUrls.length > 0 &&
              imageUrls.map((url: string, index: number) => (
                <img
                  key={index}
                  src={url}
                  alt="Uploaded"
                  className="w-12 h-12 object-cover"
                />
              ))}

            {/* FaCamera icon for opening modal */}
            <FaCamera type="button" className="cursor-pointer" onClick={openModal} />
          </div>
        }
        expandedPanel="Media"
        headerTitle="Media Info"
      />

      {!isAttachment && (
        <div className="col-span-full">
          <InputContainer
            label="Body Content"
            name="BodyContent"
            onValueChange={(event: any) => {
              handleInnerFormChange(event, 'BodyContent');
            }}
            type="rte"
            value={selectedTemplate?.BodyContent}
          />
        </div>
      )}

      {isModalMediaOpen && (
        <div className="fixed inset-0 ml-80 mt-40 flex w-[1000px] h-[400px] items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-lg w-full overflow-y-auto">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold mb-4">Add URL</h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">
                <FaTimes className="w-6 h-6" />
              </button>
            </div>
            <UploadFilesContainer onSave={handleSaveUrls} />
          </div>
        </div>
      )}
    </>
  );
}
